import React, { useState } from 'react';
import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MessagesContext from '../../../../contexts/messagesContext';
import { findUser, getUser, resetUserFound } from '../../../../redux/User/UserAction';
import { ClinicInput } from '../../../UI';
import { PropTypes } from 'prop-types';
import { CircularProgress, makeStyles } from '@material-ui/core';
import { createLoadingSelector } from '../../../../redux/Loading/LoadingSelector';
import { USER_FOUND, GET_USER } from '../../../../redux/User/UserType';
import { CloseIcon } from '../../../UI/Images/Icons';

const styles = makeStyles({
    container: {
        position: 'relative'
    },
    searchSuggestion: {
        position: 'absolute',
        width: '100%',
        bottom: '-45px',
        borderRadius: '4px',
        boxShadow: '0 2px 8px 0 rgba(84, 94, 102, 0.12)',
        border: 'solid 1px #f2f4f7',
        padding: '12px',
        zIndex: '1000',
        background: '#fff',
        cursor: 'pointer'
    },
    name: {
        fontSize: '13px',
        fontWeight: 'normal',
        display: 'block'
    },
    username: {
        fontSize: '12px',
        fontWeight: '500',
        color: '#989ea3'
    },
    loading: {
        position: 'absolute',
        left: '5px',
        top: '35px',
        width: '23px !important',
        height: '23px !important',
        color: '#063f5e'
    },
    valueWrapper: {
        padding: '15px 12px',
        border: '1.5px solid rgb(187,187,187)',
        borderRadius: '4px',
        marginBottom: '10px'
    },
    tag: {
        background: '#416ce1',
        color: '#fff',
        borderRadius: '16px',
        padding: '0px 8px',
        marginInlineStart: '8px',
        position: 'absolute',
        top: '39px',
        left: '52px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '11px'
    },
    closeIconWrapper: {
        position: 'absolute',
        top: '36px',
        left: '5px',
        cursor: 'pointer'
    },
    row: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& svg': {
            cursor: 'pointer'
        }
    }
});
const UsernameField = ({ setFieldValue, setUserSelected, ...props }) => {
    const classes = styles();
    const dispatch = useDispatch();
    const userFound = useSelector((state) => state.user.userFound);
    const user = useSelector((state) => state?.user?.user) || {};
    const loadingSelector = createLoadingSelector(USER_FOUND.REQUEST);
    const isLoading = useSelector(loadingSelector);
    const { messages } = useContext(MessagesContext);
    const [completeNumber, setCompleteNumber] = useState(false);
    const [showValue, setShowValue] = useState(false);
    const handleChangeUserName = ({ target: { value } }) => {
        if (value?.length <= 11) {
            setCompleteNumber(false);
            setFieldValue('username', value);
        }
        if (value?.length === 11) {
            setCompleteNumber(true);
            dispatch(findUser(value));
        }
    };
    const handleRemoveValue = () => {
        setFieldValue('username', '');
        setCompleteNumber(false);
    };
    const handleClick = () => {
        setUserSelected(true);
        dispatch(getUser(userFound?.id, true));
        setShowValue(true);
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && completeNumber && userFound?.id) {
            setUserSelected(true);
            dispatch(getUser(userFound?.id, true));
            setShowValue(true);
        }
    };
    const handleBlur = () => {
        if (userFound?.id) {
            setUserSelected(true);
            setShowValue(true);
            dispatch(getUser(userFound?.id, true));
            setCompleteNumber(false);
        }
        props.setTouched({ ...props.touched, ['username']: true });

        if (props.errors.username) {
            props.setFieldTouched('username', true);
        }
    };
    const handleCloseUser = () => {
        setUserSelected(false);
        setShowValue(false);
        dispatch(resetUserFound());
        dispatch({
            type: GET_USER.SUCCESS,
            payload: null
        });
    };
    return (
        <div className={classes.container}>
            {showValue && user?.id ? (
                <div className={classes.valueWrapper}>
                    <div className={classes.row}>
                        <div>
                            <span className={classes.name}>
                                {user?.first_name} {user?.last_name}
                            </span>
                            <span className={classes.username}>{user.username}</span>
                        </div>
                        <CloseIcon color="rgb(187,187,187)" onClick={handleCloseUser} />
                    </div>
                </div>
            ) : (
                <>
                    <ClinicInput
                        label={messages.phoneNumber}
                        name="username"
                        type="number"
                        width="100%"
                        {...props}
                        autoFocus
                        onChange={(e) => handleChangeUserName(e)}
                        onBlur={handleBlur}
                        onKeyDown={handleKeyDown}
                        alignment="right"
                    />
                    {isLoading ? (
                        <CircularProgress className={classes.loading} />
                    ) : userFound !== null && !userFound?.id && completeNumber ? (
                        <>
                            <div className={classes.tag}>{messages.new}</div>
                            <div className={classes.closeIconWrapper} onClick={handleRemoveValue}>
                                <CloseIcon color="#d0d0d0" />
                            </div>
                        </>
                    ) : (
                        userFound?.id &&
                        completeNumber && (
                            <div className={classes.searchSuggestion} onClick={handleClick}>
                                <span className={classes.name}>
                                    {userFound?.first_name} {userFound?.last_name}
                                </span>
                                <span className={classes.username}>{userFound?.username}</span>
                            </div>
                        )
                    )}
                </>
            )}
        </div>
    );
};
UsernameField.propTypes = {
    errors: PropTypes.object,
    setFieldValue: PropTypes.function,
    setFieldTouched: PropTypes.function,
    touched: PropTypes.object,
    setTouched: PropTypes.function,
    setUserSelected: PropTypes.function
};

export default UsernameField;
